import { TemplateRef } from '@angular/core';

export function templateRefToText(templateRef: TemplateRef<any>, context: object): string {
  let content = '';

  if (templateRef !== undefined) {
    content = '';

    const view = templateRef.createEmbeddedView(context);

    view.detectChanges();

    view.rootNodes.forEach((node) => {
      content += node.textContent || '';
    });

    view.destroy();
  }

  return content;
}
